/**
 * Feature access hook for premium gating.
 *
 * Checks whether a feature is available based on its PostHog feature flag.
 * PostHog flags act as feature-level kill switches — they control whether
 * a feature is live, NOT whether a specific user has paid.
 *
 * TODO: When subscription system is implemented (Paddle web / Adapty mobile),
 * add a second check here: flag enabled AND user has active entitlement.
 * Until then, all users are treated as premium when the feature is live.
 *
 * Usage:
 * ```tsx
 * const flagEnabled = useFeatureFlag(FeatureFlag.SHOPPING_LISTS_PREMIUM);
 * const { hasAccess } = useFeatureAccess(flagEnabled);
 * ```
 */
export function useFeatureAccess(flagEnabled: boolean | null | undefined): {
  /** True if the user has access to the feature. Defaults to true until PostHog resolves. */
  hasAccess: boolean;
  /** True while PostHog hasn't loaded yet (flagEnabled is null/undefined). */
  isLoading: boolean;
} {
  const isLoading = flagEnabled === null || flagEnabled === undefined;
  return {
    hasAccess: isLoading ? true : (flagEnabled ?? true),
    isLoading,
  };
}
